<div class="base-layout-wp">
  <router-outlet></router-outlet>
</div>
